export default __webpack_public_path__ + "static/media/ASL2.bc16f0e8.png";